import { useRef, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Upload, Loader2 } from "lucide-react";

/**
 * Reusable upload button. On success, calls onUploaded(url, meta).
 * accept: MIME/ext filter (e.g. "image/*", "video/*,image/*")
 */
export default function UploadButton({ accept = "image/*", onUploaded, label = "Upload", size = "sm", testid = "upload-button", variant = "outline" }) {
  const inputRef = useRef(null);
  const [busy, setBusy] = useState(false);

  const pick = () => inputRef.current?.click();

  const upload = async (file) => {
    if (!file) return;
    setBusy(true);
    const fd = new FormData();
    fd.append("file", file);
    try {
      const { data } = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onUploaded?.(data.url, data);
      toast.success("Uploaded");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Upload failed");
    } finally {
      setBusy(false);
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  return (
    <>
      <Button type="button" variant={variant} size={size} onClick={pick} disabled={busy} data-testid={testid} className="border-[#E8DEC8] text-[#5C061C]">
        {busy ? <Loader2 className="h-3.5 w-3.5 mr-1 animate-spin" /> : <Upload className="h-3.5 w-3.5 mr-1" />}
        {busy ? "Uploading..." : label}
      </Button>
      <input ref={inputRef} type="file" accept={accept} onChange={(e) => upload(e.target.files?.[0])} className="hidden" data-testid={`${testid}-input`} />
    </>
  );
}
